const ma = {
  "भाजपा सदस्यता अभियान - 2024": "ബി.ജെ.പി അംഗത്വ ക്യാമ്പെയ്ൻ - 2024",
  "Select Language": "ഭാഷ തിരഞ്ഞെടുക്കുക",
  Next: "അടുത്തത്",
  "Enter your mobile number": "നിങ്ങളുടെ മൊബൈൽ നമ്പർ നൽകുക",
  "I accept the Terms and Conditions, and by continuing, I consent to voluntarily become a member of the BJP":
    "ഞാൻ നിബന്ധനകളും വ്യവസ്ഥകളും അംഗീകരിക്കുന്നു, തുടരുന്നതിലൂടെ, സ്വമേധയാ ബിജെപിയിൽ അംഗമാകാൻ ഞാൻ സമ്മതിക്കുന്നു",
  "Get OTP": "OTP നേടുക",
  "Terms and Conditions": "ഉപാധികളും നിബന്ധനകളും",
  "You must tick the box to continue, as it is mandatory.":
    "തുടരാൻ നിങ്ങൾ ബോക്സിൽ ടിക്ക് ചെയ്യണം, കാരണം അത് നിർബന്ധമാണ്.",
  "Okay, Got it": "ശരി, മനസ്സിലായി",
  "Get OTP": "OTP നേടുക",
  "Enter OTP": "OTP നൽകുക",
  "Resend OTP": "OTP വീണ്ടും അയയ്‌ക്കുക",
  Continue: "തുടരുക",
  "Fill details": "വിശദാംശങ്ങൾ പൂരിപ്പിക്കുക",
  "Upload Photo": "ഫോട്ടോ അപ്‌ലോഡ് ചെയ്യുക",
  "Profile Photo": "പ്രൊഫൈൽ ഫോട്ടോ",
  "Mobile number": "മൊബൈൽ നമ്പർ",
  "Mrs.": "ശ്രീമതി",
  "Mr.": "ശ്രീ",
  Ms: "കുമാരി",
  "Full Name*": "പൂർണ്ണമായ പേര് *",
  "D.O.B": "D.O.B",
  Age: "പ്രായം",
  Gender: "ലിംഗം",
  Female: "സ്ത്രീ",
  Male: "പുരുഷൻ",
  Other: "മറ്റുള്ളവ",
  "Email Id": "ഇമെയിൽ ഐഡി",
  "Add address": "വിലാസം ചേർക്കുക",
  "House/ Flat/ Floor No.": "വീട്/ ഫ്ലാറ്റ്/ നില നമ്പർ.",
  "Current address PIN code": "നിലവിലെ വിലാസ പിൻ കോഡ്",
  "District*": "ജില്ല*",
  State: "സംസ്ഥാനം",
  "Assembly constituency (AC)": "നിയമസഭാ മണ്ഡലം (AC)",
  "Tell us about your location":
    "നിങ്ങളുടെ സ്ഥലത്തെ കുറിച്ച് ഞങ്ങളെ അറിയിക്കുക",
  "It will assist us in locating other members in your area.":
    "നിങ്ങളുടെ പ്രദേശത്തെ മറ്റ് അംഗങ്ങളെ കണ്ടെത്തുന്നതിന് ഇത് ഞങ്ങളെ സഹായിക്കും.",
  "Your address as fetched": "നിങ്ങളുടെ വിലാസം ലഭിച്ചതുപോലെ",
  "Referral code": "റഫറൽ കോഡ്",
  "I certify that above provided information is correct and there is no mistake. I know that all further communication will be done on above provided details":
    "മേൽ കൊടുത്തിരിക്കുന്ന വിവരങ്ങൾ ശരിയാണെന്ന് ഞാൻ സ്ഥിരീകരിക്കുന്നു, അത് തെറ്റുകളില്ലാതെ നൽകിയിട്ടുണ്ട്. അടുത്ത എല്ലാ ആശയവിനിമയങ്ങളും മേൽ നൽകിയ വിവരങ്ങളുടെ അടിസ്ഥാനത്തിലാണ് നടത്തപ്പെടുക എന്ന് ഞാൻ അറിയുന്നു.",
  Save: "സംരക്ഷിക്കുക",
  Select: "തിരഞ്ഞെടുക്കുക",
  Camera: "ക്യാമറ",
  or: "അല്ലെങ്കിൽ",
  Gallery: "ഗാലറി",
  "Support format : Jpeg, Png, Pdf": "പിന്തുണ ഫോർമാറ്റ്: Jpeg, Png, Pdf",
  Cancel: "റദ്ദാക്കുക",
  "Select location": "സ്ഥലം തിരഞ്ഞെടുക്കുക",
  "Provide location": "സ്ഥലം നൽകുക",
  "Search results": "തിരച്ചിലിന്റെ ഫലങ്ങൾ",
  "Search for a building, street name or..":
    "ഒരു കെട്ടിടം, തെരുവിൻ്റെ പേര് അല്ലെങ്കിൽ..",
  "Your address as fetched": "നിങ്ങളുടെ വിലാസം ലഭിച്ചതുപോലെ",
  "Locate me": "എന്നെ കണ്ടെത്തൂ",
  "Confirm location": "സ്ഥലം സ്ഥികരിക്കുക",
  "Congratulations !": "അഭിനന്ദനങ്ങൾ !",
  "Your primary Id is -": "നിങ്ങളുടെ പ്രാഥമിക ഐഡി -",
  "Login in to Bjp.org/membership to enhance your data, access your ID card, and refer others to join as primary members.":
    "നിങ്ങളുടെ ഡാറ്റ മെച്ചപ്പെടുത്തുന്നതിനും ഐഡി കാർഡ് ആക്‌സസ് ചെയ്യുന്നതിനും പ്രാഥമിക അംഗങ്ങളായി ചേരുന്നതിന് മറ്റുള്ളവരെ റഫർ ചെയ്യുന്നതിനും Bjp.org/membership-ലേക്ക് ലോഗിൻ ചെയ്യുക.",
  "ID CARD": "ഐഡി കാർഡ്",
  "You can download your generated ID Card":
    "നിങ്ങൾ സൃഷ്ടിച്ച ഐഡി കാർഡ് ഡൗൺലോഡ് ചെയ്യാം",
  Download: "ഡൗൺലോഡ് ചെയ്യുക",
  "Go to dashboard": "ഡാഷ്‌ബോർഡിലേക്ക് പോകുക",
  "View your profile": "നിങ്ങളുടെ പ്രൊഫൈൽ കാണുക",
  "Refer and add member": "റഫർ ചെയ്ത് അംഗത്തെ ചേർക്കുക",
  Share: "പങ്കിടുക",
  "To update your additional details and refer more member, please click here.":
    "നിങ്ങളുടെ കൂടുതൽ വിശദാംശങ്ങൾ അപ്‌ഡേറ്റ് ചെയ്യുന്നതിനും കൂടുതൽ അംഗങ്ങൾ റഫർ ചെയ്യുന്നതിനും, ദയവായി ഇവിടെ ക്ലിക്ക് ചെയ്യുക.",
  "Bharatiya Janata Party": "ഭാരതീയ ജനതാ പാർട്ടി",
  "6A, DEENDAYAL UPADHYAYA MARG, NEW DELHI - 110002":
    "6A, ദീനയാൽ ഉപാധ്യായ മാർഗ്, ന്യൂഡൽഹി - 110002",
  Name: "പേര്",
  "Membership Number": "അംഗത്വ നമ്പർ",
  "QR Code": "QR കോഡ്",
  "Please select a year between 1930 and 2006.":
    "1930 നും 2006 നും ഇടയിലുള്ള ഒരു വർഷം തിരഞ്ഞെടുക്കുക.",
  "Please enter a valid email address.": "സാധുവായ ഒരു ഇമെയിൽ വിലാസം നൽകുക.",
  "Please enter 6-digit PIN code.": "ദയവായി 6 അക്ക പിൻ കോഡ് നൽകുക.",
  "10-digit mobile number.": "10 അക്ക മൊബൈൽ നമ്പർ.",
  "Please enter a 10-digit mobile number.": "ദയവായി 10 അക്ക മൊബൈൽ നമ്പർ നൽകുക.",
  "Please enter your name.": "ദയവായി നിങ്ങളുടെ പേര് നൽകുക.",
  "I pledge and willing to receive regular updates from BJP":
    "ബിജെപിയിൽ നിന്ന് പതിവായി അപ്‌ഡേറ്റുകൾ സ്വീകരിക്കാൻ ഞാൻ പ്രതിജ്ഞ ചെയ്യുന്നു",
  "Get Verification Code": "സ്ഥിരീകരണ കോഡ് നേടുക",
  "Enter Verification Code": "സ്ഥിരീകരണ കോഡ് നൽകുക",
  "Resend Verification Code": "സ്ഥിരീകരണ കോഡ് പുനർവിതരണം ചെയ്യുക",
  "Provide Details": "വിശദാംശങ്ങൾ നൽകുക",
  Upload: "അപ്‌ലോഡ് ചെയ്യുക",
  Ok: "ശരി",
  Calendar: "കലണ്ടർ",
  "Full Address": "പൂര്‍ണ വിലാസം",
  "Privacy policy": "സ്വകാര്യതാ നയം",
  Disclaimer: "നിരാകരിക്കുക ",
  "Contact us": "ഞങ്ങളെ ബന്ധപ്പെടുക",
  Save: "സേവ് ചെയ്യുക",
  "Your primary member ID": "നിങ്ങളുടെ പ്രാഥമിക അംഗ ഐഡി",
  "Membership Card": "അംഗത്വ കാർഡ്",
  "Your Unique Referral code": "നിങ്ങളുടെ വ്യത്യസ്ത റിഫറൽ കോഡ്",
  "Invite and add member": "ക്ഷണിക്കാം കൂടാതെ അംഗത്തെ ചേർക്കാം",
  Share: "പങ്കുവെക്കുക",
  "Click below to add more details, donate and add other members to BJP":
    "കൂടുതൽ   അംഗങ്ങളെ BJP-യിൽ ചേർക്കാൻ താഴെ click ചെയ്യുക",
  "Update your details": "നിങ്ങളുടെ വിശദാംശങ്ങൾ അപ്‌ഡേറ്റ് ചെയ്യുക",
  "Add Referral Details": "റിഫറൽ വിശദാംശങ്ങൾ ചേർക്കുക",
  "Referred by (name)": "റിഫറർ (പേരു)",
  "Referred by (mobile number)": "റിഫറർ (മൊബൈല്‍ നമ്പര്‍)",
  Capture: "ഫോട്ടോ എടുക്കുക",
  "Close Camera": "ക്യാമറ ഓഫ് ചെയ്യുക",
  Uploading: "അപ്‌ലോഡ് ചെയ്യുന്നു",
  "Your Unique Referral Link": "നിങ്ങളുടെ റഫറൽ ലിങ്ക്",
  "You've reached the maximum OTP attempts for today. Please try again tomorrow":
    "ഇന്നത്തെ പരമാവധി OTP ശ്രമങ്ങളിൽ നിങ്ങൾ എത്തിയിരിക്കുന്നു. ദയവായി നാളെ വീണ്ടും ശ്രമിക്കുക",
  Miss: "കുമാരി",
  "Full Name": "പൂർണ്ണമായ പേര്",
  "OTP limit reached for today. Please try again tomorrow":
    "ഇന്നത്തെ ഒടിപി പരിധി കഴിഞ്ഞു . ദയവായി നാളെ വീണ്ടും ശ്രമിക്കുക",
  ": is not a Primary Member, Only Primary Members can refer":
    ": ഒരു പ്രാഥമിക അംഗമല്ല, പ്രാഥമിക അംഗങ്ങൾക്ക് മാത്രമേ റഫർ ചെയ്യാൻ കഴിയൂ",
  "Please enter valid fullname": "മുഴുവൻ പേര് നൽകുക",
  Upload: "അപ്‌ലോഡ് ചെയ്യുക",
};

export default ma;
